module.exports = __webpack_public_path__ + "img/401.1ea165a0.png";